<template>
  <el-card class="h-full overflow-y-scroll">
    <!-- header -->
    <el-row class="">
      <div class="text-18px h-20px font-800">数据总览</div>
      <div class="flex flex-nowrap justify-between">
        <div class="flex my-20px pr-10px float-left" style>
          <div class="flex items-center mr-10px">
            <span class="iconfont icon-line-list text-red-500 text-28px leading-28px"></span>
          </div>
          <div class="flex flex-col" @click="routerToDataSource">
            <span class="text-red-500 font-600">{{ totalSource }}个</span>
            <span class="font-400">接入数据源数量 </span>
          </div>
        </div>
        <div class="flex my-20px pr-10px float-left">
          <div class="flex items-center mr-10px">
            <span class="iconfont icon-line-expand text-green-500 text-28px leading-28px"></span>
          </div>
          <div @click="routerToProtocol" class="flex flex-col">
            <span class="text-green-500 font-600">{{ agreementQuantitle }}个</span>
            <span>协议接口数量 </span>
          </div>
        </div>
        <div class="flex my-20px pr-10px float-left">
          <div class="flex items-center mr-10px">
            <span class="iconfont icon-line-calendar text-yellow-500 text-28px leading-28px"></span>
          </div>
          <div @click="routerToDataView" class="flex flex-col">
            <span class="text-yellow-500 font-600">{{ indexTotalNumber }}个</span>
            <span>测点总数 </span>
          </div>
        </div>

        <div class="flex my-20px pr-10px float-left">
          <div class="flex items-center mr-10px">
            <span class="iconfont icon-line-contract text-yellow-500 text-28px leading-28px"></span>
          </div>
          <div class="flex flex-col">
            <span class="text-yellow-500 font-600">{{ changeUnite(realTimeNumber) }}条</span>
            <span>实时数据总量(条) </span>
          </div>
        </div>
      </div>
    </el-row>
    <div class="h-full">
      <el-card class="h-500px mt-20px">
        <el-row :gutter="20" class="h-full flex-auto">
          <el-col :span="12" class="h-full text-16px font-bold">
            <el-row :gutter="10" class="h-40px flex items-center mb-10px">
              <el-col :span="12"><div>数据源离线统计</div></el-col>
              <el-col :span="12"><div>监控的测点离线统计</div></el-col>
            </el-row>
            <el-row :gutter="10" class="h-400px w-full">
              <el-col :span="12" class="h-full z-999999">
                <v-chart
                  :options="options1"
                  autoresize
                  :theme="currentTheme"
                  class="w-full h-full"
                  @click="dataSourceTotall"
                  ref="options1"
                ></v-chart>
              </el-col>
              <el-col :span="12" class="h-full">
                <v-chart
                  :options="optionsPoint"
                  autoresize
                  :theme="currentTheme"
                  @click="monitorTotall"
                  class="w-full h-full"
                  ref="optionsPoint"
                ></v-chart>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" class="h-full text-16px font-bold">
            <div class="flex justify-between h-40px items-center mb-20px">
              <div class="">数据源接入数据量统计</div>
              <div>
                <el-select
                  multiple
                  v-model="sourceDataNumber"
                  size="small"
                  value-key="id"
                  class="flex-nowrap truncate h-40px leading-40px !w-280px mr-10px"
                  @change="changeDataresourceData"
                  placeholder="选择显示的数据源"
                >
                  <el-option
                    class="flex-nowrap truncate"
                    v-for="item in sourceDataDisplayOptions"
                    :key="item.id"
                    :label="item.dataSourceName"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="h-400px pb-10px overflow-y-scroll">
              <el-table
                class="h-full"
                v-loading="tableLoading"
                border
                stripe
                header-align="left"
                :highlight-current-row="true"
                row-key="id"
                :data="tableData"
                :height="tableHeight"
              >
                <el-table-column type="index" label="序号" width="100" />
                <el-table-column prop="dataSourceName" label="数据源名称" />
                <el-table-column prop="totalDataSize" label="接入的数据总量(条)">
                  <template #default="scope">
                    <span>{{ changeUnite(scope.row.totalDataSize) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="lastStasticsTime" label="最后一次统计时间" />
              </el-table>
            </div>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="h-500px mt-20px">
        <el-row :gutter="20" class="flex-auto h-full">
          <el-col :span="12" class="h-full">
            <div class="h-full w-full">
              <div class="text-16px font-bold h-full">
                <el-row :gutter="20" class="h-40px">
                  <el-col :span="12"> <div>数据源离线排行榜(top10)</div> </el-col>
                  <el-col :span="12"> <div>监控的测点离线排行榜(top10)</div></el-col>
                </el-row>

                <div class="h-400px">
                  <el-row :gutter="20" class="h-full w-full">
                    <el-col :span="12" class="h-full">
                      <v-chart
                        :theme="currentTheme"
                        :options="optionsData"
                        autoresize
                        @click="offLineChange"
                        class="w-full h-400px"
                        ref="optionsData"
                      ></v-chart
                    ></el-col>
                    <el-col :span="12" class="h-full">
                      <v-chart
                        :theme="currentTheme"
                        :options="pointOffLineTopData"
                        @click="offPointChange"
                        autoresize
                        class="w-full h-400px"
                        ref="pointOffLineTopData"
                      ></v-chart>
                      <div ref="pointOffLineTop" id="pointOffLineTop" class="h-full w-full"></div
                    ></el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="h-full">
            <div class="right-pane">
              <div class="text-16px font-bold flex justify-between h-30px">
                <div class="h-30px">资源的使用情况</div>
                <div class="h-30px">
                  <el-select
                    filterable
                    class="!w-280px mr-10px"
                    v-model="sourceDataDisplay"
                    size="small"
                    placeholder="数据源名称"
                  >
                    <el-option
                      v-for="item in sourceDataDisplayOptions"
                      :key="item.id"
                      :label="item.dataSourceName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="mt-30px">
                <div>
                  <el-row :gutter="20" class="mb-10">
                    <el-col :span="8">
                      <el-card class="w-full">
                        <el-col :span="8" class="tc">
                          <span class="iconfont icon-bg-circular text-red-500 text-30px"></span>
                        </el-col>
                        <el-col :span="16" class="!h-80px">
                          <div class="b tc">CPU使用率</div>
                          <div class="tc text-red-500">
                            <!-- <span class="unit text-12px organge"
                              >{{ toFixedNumber(currentUsageSourceData.cpuUsage)
                              }}{{ currentUsageSourceData.cpuUsageUnit }}</span
                            > -->
                            <span class="unit text-12px organge"
                              >{{ toFixedNumber(currentUsageSourceData.cpuUsage) }}%</span
                            >
                          </div>
                        </el-col>
                      </el-card>
                    </el-col>
                    <el-col :span="8">
                      <el-card class="w-full">
                        <el-col :span="8" class="tc">
                          <span class="iconfont icon-bg-circular text-green-500 text-30px"></span>
                        </el-col>
                        <el-col :span="16" class="!h-80px">
                          <div class="b tc">内存使用率</div>
                          <div class="tc text-green-500">
                            <!-- <span class="unit organge text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.memUsage)
                              }}{{ currentUsageSourceData.memUsageUnit }}</span
                            > -->
                            <span class="unit organge text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.memUsage) }}%</span
                            >
                          </div>
                        </el-col>
                      </el-card>
                    </el-col>
                    <el-col :span="8">
                      <el-card class="w-full">
                        <el-col :span="8" class="tc">
                          <span class="iconfont icon-bg-pc text-yellow-500 text-30px"></span>
                        </el-col>
                        <el-col :span="16" class="!h-80px">
                          <div class="b tc">数据磁盘剩余量</div>
                          <div class="tc text-yellow-500">
                            <!-- <span class="unit bule text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.diskAvailable)
                              }}{{ currentUsageSourceData.diskAvailableUnit }}</span
                            > -->
                            <span class="unit bule text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.diskAvailable) }}GB</span
                            >
                          </div>
                        </el-col>
                      </el-card>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="mb-10">
                    <el-col :span="8">
                      <el-card class="w-full">
                        <el-col :span="8" class="tc">
                          <span class="iconfont icon-bg-pc text-green-500 text-30px"></span>
                        </el-col>
                        <el-col :span="16" class="!h-80px">
                          <div class="b tc">以太网发送流量</div>
                          <div class="tc text-green-500">
                            <!-- <span class="unit bule text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.netBytesRecv)
                              }}{{ currentUsageSourceData.netBytesRecvUnit }}</span
                            > -->
                            <span class="unit bule text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.netBytesSent) }}KB</span
                            >
                          </div>
                        </el-col>
                      </el-card>
                    </el-col>
                    <el-col :span="8">
                      <el-card class="w-full">
                        <el-col :span="8" class="tc">
                          <span class="iconfont icon-bg-pc text-green-500 text-30px"></span>
                        </el-col>
                        <el-col :span="16" class="!h-80px">
                          <div class="b tc">以太网接收流量</div>
                          <div class="tc text-green-500">
                            <!-- <span class="unit bule text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.netBytesRecv)
                              }}{{ currentUsageSourceData.netBytesRecvUnit }}</span
                            > -->
                            <span class="unit bule text-12px"
                              >{{ toFixedNumber(currentUsageSourceData.netBytesRecv) }}KB</span
                            >
                          </div>
                        </el-col>
                      </el-card>
                    </el-col>
                  </el-row>
                </div>
                <div class="title_header">
                  <span
                    >当前时间:
                    <span class="text-blue-500 bule mr-20 ml-20">{{ currentTime }}</span></span
                  >
                </div>
              </div>
            </div></el-col
          >
        </el-row>
      </el-card>
    </div>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import { forEach, sortBy, find } from 'lodash'
import StandardManagementService from '@/services/dataCollectionManageService'
import StandardManageService from '@/services/common/StandardManagementService'

export default {
  name: 'TimeServiceMonitoring',
  props: {
    standardId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pointOffLineTop: '',
      hasRecord: {
        remark: '',
      }, // 判断数据源接入数据量统计是已保存数据
      currentTime: '',
      sourceDataNumber: [],
      totalSource: 0,
      currentUsageSourceData: {},
      agreementQuantitle: 0,
      indexTotalNumber: 0,
      totalPointsNumber: 0,
      trendModelNumber: 0,
      logicModelNumber: 0,
      dataOffline: '',
      realTimeNumber: 0,
      sourceDataDisplayOptions: [],
      tableLoading: false,
      tableData: [],
      sourceDataDisplay: '',
      startTime: '',
      endTime: '',
      currentDataSource: '',
      optionsData: {
        grid: {
          top: 10,
          left: 80,
          right: 20,
          bottom: 50,
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            interval: 0,
            color: 'rgba(94,94,94,1)',
            fontSize: 12,
            formatter: '{value}次',
          },
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          splitLine: {
            show: true,
          },
        },
        yAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
              color: 'rgba(94,94,94,1)',
              fontSize: 12,
              formatter: '{value}次',
            },
          },
          axisPointer: {
            type: 'shadow',
          },
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
            },
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['#528DFF'],
        series: [
          {
            name: '离线次数',
            type: 'bar',
            barWidth: 10,
            barGap: '20%',
            stack: 'total',
            label: {
              show: true,
              position: 'right',
              color: '#528DFF',
            },
            data: [],
          },
        ],
      },
      pointOffLineTopData: {
        grid: {
          top: 10,
          left: 80,
          right: 20,
          bottom: 50,
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            interval: 0,
            color: 'rgba(94,94,94,1)',
            fontSize: 12,
            formatter: '{value}次',
          },
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          splitLine: {
            show: true,
          },
        },
        yAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            show: true,
            textStyle: {
              color: 'rgba(94,94,94,1)',
              fontSize: 12,
              formatter: '{value}次',
            },
          },
          axisPointer: {
            type: 'shadow',
          },
          axisTick: {
            show: true,
          },
          axisLine: {
            show: true,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
            },
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['#528DFF'],
        series: [
          {
            name: '离线次数',
            type: 'bar',
            barWidth: 10,
            barGap: '20%',
            stack: 'total',
            label: {
              show: true,
              position: 'right',
              color: '#528DFF',
            },
            data: [],
          },
        ],
      },
      options1: {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: false,
          data: ['数据源离线统计'],
          itemWidth: 12, // 色标图宽
          itemHeight: 12, // 色标图高
          y: 'bottom',
          x: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        grid: {
          top: 20,
          left: 40,
          bottom: 40,
          right: 0,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: 'rgba(94,94,94,1)',
              },
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: 'rgba(94,94,94,1)',
                fontSize: 12,
              },
            },
            axisTick: {
              show: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            max: 100,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(94,94,94,1)',
              },
            },
            axisLabel: {
              color: 'rgba(94,94,94,1)',
              fontSize: 12,
              formatter: '{value}个',
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(94,94,94,1)',
              },
            },
          },
        ],
        series: [
          {
            name: '离线个数',
            type: 'line',
            data: [],
            itemStyle: {
              color: 'rgb(82, 141, 255)',
            },
          },
        ],
      },
      options: {
        options1: {
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            show: false,
            data: ['数据源离线统计'],
            itemWidth: 12, // 色标图宽
            itemHeight: 12, // 色标图高
            y: 'bottom',
            x: 'center',
            textStyle: {
              color: '#fff',
              fontSize: 12,
            },
          },
          grid: {
            top: 20,
            left: 40,
            bottom: 40,
            right: 0,
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisLine: {
                lineStyle: {
                  color: 'rgba(94,94,94,1)',
                },
              },
              axisLabel: {
                interval: 0,
                textStyle: {
                  color: 'rgba(94,94,94,1)',
                  fontSize: 12,
                },
              },
              axisTick: {
                show: true,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              max: 100,
              axisLine: {
                show: false,
                lineStyle: {
                  color: 'rgba(94,94,94,1)',
                },
              },
              axisLabel: {
                color: 'rgba(94,94,94,1)',
                fontSize: 12,
                formatter: '{value}个',
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  color: 'rgba(94,94,94,1)',
                },
              },
            },
          ],
          series: [
            {
              name: '离线个数',
              type: 'line',
              data: [],
              itemStyle: {
                color: 'rgb(82, 141, 255)',
              },
            },
          ],
        },
      },
      optionsPoint: {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: false,
          data: ['离线个数'],
          itemWidth: 12, // 色标图宽
          itemHeight: 12, // 色标图高
          y: 'bottom',
          x: 'center',
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        grid: {
          top: 20,
          left: 40,
          bottom: 40,
          right: 0,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLine: {
              lineStyle: {
                color: 'rgba(94,94,94,1)',
              },
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: 'rgba(94,94,94,1)',
                fontSize: 12,
              },
            },
            axisTick: {
              show: true,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            max: 100,
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(94,94,94,1)',
              },
            },
            axisLabel: {
              color: 'rgba(94,94,94,1)',
              fontSize: 12,
              formatter: '{value}个',
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(94,94,94,1)',
              },
            },
          },
        ],
        series: [
          {
            name: '离线个数',
            type: 'line',
            data: [],
            itemStyle: {
              color: 'rgb(82, 141, 255)',
            },
          },
        ],
      },
      // standardId: '',
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 10px)'
    },
    config() {
      return _.get(Wiz, 'globalSettings.dynamicModules.modules["data-collection"].config')
    },
    currentTheme() {
      return this.$store.getters['System/currentTheme'] || []
    },
  },
  mounted() {},
  methods: {
    // 跳转到离线测点
    monitorTotall() {
      this.$router.push({ name: 'measuring-point', query: { state: 1 } })
    },
    // 跳转到离线统计
    dataSourceTotall() {
      this.$router.push({ name: 'monitor-management', query: { state: 1 } })
    },
    // 离线
    offLineChange(value) {
      // 配置文件withoutAuth true表示免登陆1区 false表示三区可以进行跳转
      if (this.config && this.config.withoutAuth) {
        return
      }
      const data = value.data.name
      this.$router.push({ name: 'monitor-management', query: { name: data } })
    },
    offPointChange(value) {
      if (this.config && this.config.withoutAuth) {
        return
      }
      const data = value.data.name
      this.$router.push({ name: 'measuring-point', query: { name: data } })
    },
    // 跳转到数据源
    routerToDataSource() {
      this.$router.push({ name: 'config-management' })
    },
    // 跳转到协议管理
    routerToProtocol() {
      this.$router.push({ name: 'interface-protocol' })
    },
    // 跳转到数据查看
    routerToDataView() {
      this.$router.push({ name: 'data-view' })
    },
    toFixedNumber(data) {
      return data ? data.toFixed(2) : data
    },
    // 单位转化
    changeUnite(num, s, step, unit) {
      s = s || 0
      step = step || 10000
      if (Math.abs(num) >= step) {
        return this.changeUnite(num / step, s + 1, step, unit)
      }
      const relUnit = unit || ['', '万', '亿', '兆', '京', '垓', '种']
      return num.toFixed(2) + relUnit[s]
    },
    // 获取数据总览
    async getAllCollectData() {
      const res = await StandardManageService.getDataOverview(this.standardId)
      if (res && res.code === 0 && res.data) {
        this.totalSource = res.data.dataSourceCount
        this.agreementQuantitle = res.data.protocolTypeCount
        this.indexTotalNumber = res.data.pointCount
        this.totalPointsNumber = res.data.indexCount
      }
    },
    // 获取数据源离线统计
    async getDailyOffline() {
      const res = await StandardManageService.getDailyOfflineData(this.standardId)
      if (res && res.code === 0 && res.data) {
        for (const key in res.data) {
          this.options1.xAxis[0].data.push(key)
          this.options1.series[0].data.push(res.data[key])
        }
      }
    },
    // 获取监控的测点离线统计
    async getMonotoringPoint() {
      const res = await StandardManageService.getMonotoringPointData(this.standardId)
      if (res && res.code === 0 && res.data) {
        for (const key in res.data) {
          this.optionsPoint.xAxis[0].data.push(key)
          this.optionsPoint.series[0].data.push(res.data[key])
        }
      }
    },
    // 获取数据源接入的数据量统计
    async getDatasourceVolume() {
      const res = await StandardManageService.getDatasourceVolumeData({
        standardId: this.standardId,
        datasourceId: this.sourceDataNumber,
      })
      console.log(res, 'res--88')
      if (res && res.code === 0 && res.data) {
        this.tableData = res.data
      }
    },
    // 获取数据源离线排行
    async getDatasourceStatistics() {
      const res = await StandardManageService.getDatasourceStatisticsData(this.standardId)
      if (res && res.code === 0 && res.data) {
        res.data.forEach((val) => {
          this.optionsData.yAxis.data.push(val.sourceName)
          this.optionsData.series[0].data.push({
            value: val.offlineCount,
            name: val.dataSourceName,
          })
        })
      }
    },
    // 获取监控的测点离线排行
    async getMonitorPointStatistics() {
      const res = await StandardManageService.getMonitorPointStatisticsData(this.standardId)
      if (res && res.code === 0 && res.data) {
        this.pointOffLineTopData.series[0].data = []
        res.data.forEach((val) => {
          this.pointOffLineTopData.yAxis.data.push(val.sourceName)
          this.pointOffLineTopData.series[0].data.push({
            value: val.offlineCount,
            name: val.sourceName,
          })
        })
      }
    },
    // 获取服务器资源使用情况
    async getResourceUsage() {
      const res = await StandardManageService.getResourceUsageData(
        this.sourceDataDisplay || this.sourceDataDisplayOptions[0].id
      )
      console.log('获取服务器资源使用情况', res)
      if (res && res.code === 0 && res.data) {
        this.currentUsageSourceData = res.data
      }
    },
    // 获取数据源/实体列表
    async getCollectDataSource() {
      const res = await StandardManageService.getCollectDataSourceData()
      if (res && res.code === 0 && res.data) {
        this.sourceDataDisplayOptions = res.data
        this.sourceDataDisplay = this.sourceDataDisplayOptions[0].id
        this.getResourceUsage()
      }
    },
    // 数据源接入数据量统计切换数据源
    changeDataresourceData(dataid) {
      this.getDatasourceVolume(dataid)
    },
    async init() {
      // await this.getAllCollectData()
      // await this.getDailyOffline()
      // await this.getMonotoringPoint()
      // await this.getDatasourceStatistics()
      // await this.getMonitorPointStatistics()
      // await this.getResourceUsage()
      // await this.getCollectDataSource()
    },
  },
  watch: {
    // 监听数据源改变
    sourceDataDisplay: {
      handler(data) {
        // this.currentUsageSourceData = find(this.sourceDataDisplayOptions, {
        //   id: data,
        // })
        this.getResourceUsage()
        this.currentTime = dayjs(this.currentUsageSourceData.flushTime).format('HH:mm:ss')
      },
      deep: true,
    },
    standardId: {
      handler(data) {
        if (data) {
          console.log(data, 'standardId')
          this.getDatasourceVolume() // 初始化获取数据源数据量
          this.getAllCollectData()
          this.getDailyOffline()
          this.getMonotoringPoint()
          this.getDatasourceStatistics()
          this.getMonitorPointStatistics()
          this.getCollectDataSource()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // this.getOfflineLeaderBoards()
    // this.getDataSourceOfflineLeaderboard()
    // this.getPointOffLineStatistics()
    // this.getDataSourceOffLineStatistics()
    // this.init()
  },
  created() {},
}
</script>

<style scoped lang="scss">

::v-deep .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}
::v-deep .el-card__body {
  height: 100%;
}

</style>
